import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import SuccessIcon from "../../assets/images/ic_successverification.png";
import ErrorIcon from "../../assets/images/ic_failedverification.png";

const VerificationResult = (props) => {
  const { scenario, onNextClick, onRetryClick } = props;
  const { t } = useTranslation();
  return (
    <>
      {scenario === "success" && (
        <div className="wrapper__container-card-body verification-result">
          <div className="wrapper__container-card-body-heading">
            <img
              src={SuccessIcon}
              alt="success"
              className="wrapper__container-card-body-heading-img"
            />
          </div>
          <h1 className="wrapper__container-card-body-title">
            {t("pages.identity.verificationResult.successHeading")}
          </h1>
          <p className="wrapper__container-card-body-desc">
            {t("pages.identity.verificationResult.successMessage")}
          </p>
        </div>
      )}
      {scenario === "error" && (
        <div className="wrapper__container-card-body verification-result">
          <div className="wrapper__container-card-body-heading">
            <img
              src={ErrorIcon}
              alt="success"
              className="wrapper__container-card-body-heading-img"
            />
          </div>
          <h1 className="wrapper__container-card-body-title">
            {t("pages.identity.verificationResult.errorHeading")}
          </h1>
          <p className="wrapper__container-card-body-desc">
            {t("pages.identity.verificationResult.errorIssue")}
          </p>
          <p className="wrapper__container-card-body-desc">
            {t("pages.identity.verificationResult.errorHelp")}
            &nbsp;
            <a href="tel:1-800-CT.GOV">
              {t("pages.identity.verificationResult.errorHelpLink")}
            </a>
            &nbsp;
            {t("pages.identity.verificationResult.errorHelpContinued")}
          </p>
          <p className="wrapper__container-card-body-desc">
            {t("pages.identity.verificationResult.errorAction")}
            &nbsp;
            <Button
              variant="link"
              className="wrapper__container-card-body-desc-text-btn"
              onClick={() => onRetryClick()}
            >
              {t("pages.identity.verificationResult.errorActionLink")}
            </Button>
          </p>
        </div>
      )}
      <div className="separator" />
      <div className="wrapper__container-card-footer">
        {scenario === "success" ? (
          <Button
            className="wrapper__container-card-body-submit"
            size="lg"
            variant="primary"
            block
            type="submit"
            onClick={(e) => onNextClick(e)}
          >
            {t("pages.identity.continue")}
            <img src={RightArrow} alt="" />
          </Button>
        ) : (
          <Button
            className="wrapper__container-card-body-submit"
            size="lg"
            variant="primary"
            block
            type="submit"
            onClick={(e) => onNextClick(e)}
          >
            {t("pages.identity.backToLink")}
            <img src={RightArrow} alt="" />
          </Button>
        )}
      </div>
    </>
  );
};

VerificationResult.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  onRetryClick: PropTypes.func.isRequired,
  scenario: PropTypes.string.isRequired,
};

export default VerificationResult;
